import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FinancialNumberPipe } from '@components/backtest-report/financial-number.pipe';
import { ApplicationSwitcherModule } from '@core/application-switcher/application-switcher.module';
import { EmpyreanLoaderModule } from '@core/empyrean-loader/empyrean-loader.module';
import { NoDataComponent } from '@core/no-data/no-data.component';
import { AbsoluteNumberPipe } from '@shared/angular/absolute-number.pipe';
import { DashboardCurrencyPipe } from '@shared/angular/dashboard-currency.pipe';
import { DebounceClickDirective } from '@shared/angular/debounce-click.directive';
import { DurationPipe } from '@shared/angular/duration.pipe';
import { GetRecordStatusPipe } from '@shared/angular/get-record-status.pipe';
import { NumberPolyPipe } from '@shared/angular/number-poly.pipe';
import { TimeAgoPipe } from '@shared/angular/time-ago.pipe';
import { NavigateToProductPageDirective } from '@shared/navigate-to-product-page.directive';
import { BacktestNumberDisplayComponent } from './backtest-number-display/backtest-number-display.component';
import { EmptyComponent } from './empty/empty.component';
import { ProgressbarComponent } from './progressbar/progressbar.component';
import { NotificationButtonComponent } from '../components/notification/notification-button/notification-button.component';

const sharedModules = [
  AbsoluteNumberPipe,
  NumberPolyPipe,
  DashboardCurrencyPipe,
  FinancialNumberPipe,
  EmptyComponent,
  GetRecordStatusPipe,
  DurationPipe,
  TimeAgoPipe,
  DebounceClickDirective,
  ProgressbarComponent,
  BacktestNumberDisplayComponent,
  NavigateToProductPageDirective,
  NoDataComponent,
  NotificationButtonComponent

];

@NgModule({
  declarations: sharedModules,
  imports: [CommonModule, EmpyreanLoaderModule, ApplicationSwitcherModule],
  exports: [sharedModules, CommonModule]
})
export class SharedModule {}
